import Styled from 'styled-components';

export const FlightCard = Styled.div`
    background: var(--background-app);
    margin-bottom: 24px;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
    overflow: hidden;
    color: var(--text-color);
    font-family: var(--font-family-base);

    .row {
        display: flex;
        flex-wrap: wrap;
        margin: 0 !important;
    }

    .container, .container-fluid {
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }

    .text-center { text-align: center; }
    .text-left { text-align: left; }
    .text-right { text-align: right; }

    @media (max-width: 767px) {
        .mobile-hidden { display: none !important; }
    }
`;

export const TarifaSection = Styled.div`
    padding: 24px 15px 20px;

    .company-box {
        text-align: center;
        img {
            max-height: 45px;
            max-width: 100%;
            object-fit: contain;
        }
        .company-name {
            font-size: 13px;
            margin-top: 5px;
            text-transform: capitalize;
            color: var(--text-color);
        }
    }

    .tarifa-col {
        padding-left: 10px !important;
    }

    .tarifa-titulo {
        font-size: 14px;
        margin-bottom: 0px;
        color: var(--text-color);
    }

    .tarifa-valor-container {
        display: flex;
        align-items: baseline;
        color: var(--title-color);
    }

    .tarifa-valor {
        font-weight: 700;
        font-size: 36px;
        line-height: 1;
    }

    .tarifa-pontos {
        font-weight: 700;
        font-size: 16px;
        margin-left: 5px;
    }

    .tarifa-desc {
        display: block;
        font-size: 12px;
        color: var(--text-color);
        margin-top: 8px;
        margin-bottom: 12px;
        line-height: 1.4;
        
        strong {
            font-weight: 700;
        }
    }
`;

export const SelectButton = Styled.button`
    background: var(--button-disabled-color) !important;
    border: 1px solid var(--button-disabled-color);
    color: var(--button-primary-text) !important;
    cursor: not-allowed;
    opacity: 0.5;
    
    ${props => !props.disabled && `
        background: var(--button-primary-color) !important;
        background: linear-gradient(143deg, var(--button-primary-color) 0%, var(--button-primary-color) 100%) !important;
        border: 1px solid var(--button-primary-color);
        cursor: pointer;
        opacity: 1;
    `}

    padding: 10px 24px;
    font-family: var(--font-family-base);
    font-weight: 500;
    font-size: 16px;
    text-transform: uppercase;
    width: 100%;
    border-radius: 4px;
    transition: background 0.2s, border-color 0.2s, cursor 0.2s;
    height: 45px;

    &:hover {
        ${props => !props.disabled && `
            opacity: 0.9;
        `}
    }
`;

export const SegmentHeader = Styled.div`
    padding: 12px 15px;
    background: #E6E6E6;
    display: flex;
    align-items: center;

    .header-content {
        display: flex;
        align-items: center;
        width: 100%;
    }

    img.icon-aviao {
        height: 32px;
        margin-right: 12px;
    }

    .ida-label {
        font-size: 20px;
        font-weight: 700;
        color: var(--title-color);
        margin-right: 10px;
    }

    .ida-info {
        font-size: 14px;
        font-weight: 400;
        color: var(--text-color);
        opacity: 0.8;
    }
`;

export const FlightInfo = Styled.div`
    padding: 20px 0;
    border-top: 1px solid #F3F2F2;

    .row-main {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px;
    }

    .radio-col { width: 35px; }
    .hora-col { width: 85px; text-align: center; }
    .timeline-col { flex: 1; padding: 0 10px; text-align: center; }
    .info-col { width: 35px; text-align: center; }

    .custom-ll-radio {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        
        img { display: none; }

        input[type="radio"] {
            display: flex;
            appearance: none;
            -webkit-appearance: none;
            width: 22px;
            height: 22px;
            border: 2px solid var(--primary-color);
            border-radius: 50%;
            margin: 0;
            position: relative;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            outline: none;
            transition: all 0.2s ease;

            &:checked::after {
                content: "";
                width: 12px;
                height: 12px;
                background: var(--primary-color);
                border-radius: 50%;
                display: block;
            }
        }
    }

    .voo-hora-box {
        .sigla { font-weight: 700; font-size: 13px; color: var(--title-color); display: block; }
        .local { font-size: 11px; color: var(--text-color); display: block; line-height: 1.2; opacity: 0.6; }
        .hora { font-weight: 700; font-size: 18px; color: var(--title-color); margin-top: 2px; display: block; }
    }

    .timeline-box {
        .txt-direto { font-size: 11px; color: var(--text-color); margin-bottom: 2px; opacity: 0.6; }
        hr.hr-timeline {
            border: 0;
            border-top: 2px solid var(--primary-color);
            margin: 4px auto;
            width: 100%;
            opacity: 1;
        }
        .txt-duration { font-size: 11px; color: var(--text-color); }
    }

    .btn_open_flight_info {
        cursor: pointer;
        img { height: 24px; }
    }

    .bagagem-row {
        margin-top: 10px;
        padding-left: 15px;
        display: flex;
        align-items: center;
        gap: 10px;

        .label-bagagem { font-size: 11px; color: var(--text-color); }
        .icons-pilha {
            display: flex;
            align-items: center;
            gap: 5px;
            img { height: 22px; &.opacity-04 { opacity: 0.2; } }
            img:first-of-type { filter: contrast(1600%); }
        }
    }
`;

export const BaggageNotice = Styled.div`
    background: #EDF5F9;
    border-radius: 4px;
    margin: 0 15px 20px;
    padding: 10px 15px;
    display: flex;
    align-items: center;
    gap: 10px;

    img { height: 18px; }
    p { color: #006C8E; font-size: 13px; font-weight: 500; margin: 0; }
`;
